import { loggedIn } from '@/router/middlewares';

export default [
  {
    path: '',
    name: 'schedules',
    props: true,
    component: () => import(/* webpackChunkName: "apps" */ './page.vue'),
    meta: {
      middleware: [loggedIn]
    },
    children: [
      {
        path: ':id',
        name: 'schedulesTableComponent',
        props: true,
        meta: {
          rootRouteName: 'schedules'
        },
        component: () =>
          import(/* webpackChunkName: "appTableComponent" */ './item/index.vue')
      }
    ]
  },
  {
    path: '',
    redirect: { name: 'schedules' }
  }
];
